export const initialParams = {
	searchDTO: {
		searchType: '',
		searchWord: '',
	},
	orderDTO: {
		orderType: '',
		orderWord: '',
	},
	pageDTO: {
		curPage: 1,
		pagePerRow: 10,
	},
};
export const initialData = {
	list: [],
	params: initialParams,
};
